import { jsx as _jsx } from "react/jsx-runtime";
import AssetCard from './AssetCard';

const ThemeCard = (props = {}) => /*#__PURE__*/_jsx(AssetCard, Object.assign({}, props, {
  offeringType: "THEME"
}));

export default ThemeCard;